/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingRecordStatesResponse {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingRecordStatesResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingRecordStatesResponse>): AwsSecurityHubFindingRecordStatesResponse {
        let obj = Object.assign(new AwsSecurityHubFindingRecordStatesResponse(), model);
        AwsSecurityHubFindingRecordStatesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingRecordStatesResponse>): AwsSecurityHubFindingRecordStatesResponse {
        if (!model) return null;
        return AwsSecurityHubFindingRecordStatesResponse.newInstance(<AwsSecurityHubFindingRecordStatesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingRecordStatesResponse) {
        if (!obj) return;

        models.AwsSecurityHubFindingRecordStatesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingRecordStatesResponse): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingRecordStatesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Record States
     */
    record_states: Array<string>;

}
